import type { QueryClient } from '@tanstack/react-query'
import { BANKING_KEYS } from '@/lib/query-keys'

/**
 * Invalidate every cache a saved manual edit of a credit card can change.
 *
 * Only Credit Card Availability: its RPC is the one reader of the manual
 * values. Cards are excluded from Cash Position, Bank Balance and the KPI tiles
 * (ADR 0017), and the account lists in Settings show none of the edited
 * figures.
 *
 * @param queryClient - The active query client
 * @returns Settles once the mounted table has refetched, so a mutation that
 *   returns it stays pending until the list shows the saved values
 */
export function invalidateAfterCreditCardManualEdit(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: BANKING_KEYS.allCreditCardAvailability })
}

